
import React from 'react'
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({

	page: {
	},
	receipt: {
		margin:20,
		marginTop:20,
		marginBottom:0,
		border: 1,
		borderColor: '#999',
		padding: "10 20 10 20"
	},
	line: {
		fontSize: 12,
		marginBottom: 5,
		marginTop: 5
	}
});

export default function PaymentPDF({payments}) {

	return (
		<Document>
			<Page size="A4" wrap>
				{payments && (payments.length>0) && payments[0].id && payments.map(pay => 
					<View style={styles.receipt} wrap={false} key={pay.id}>
						<Text style={styles.line}>Periodo: {pay.month} / {pay.year}</Text>
						<Text style={styles.line}>Cobrador: BoleBus S.L.</Text>
						<Text style={styles.line}>Recibí de: {pay.user.full_name}</Text>
						<Text style={styles.line}>Cantidad: {pay.price} €</Text>
					</View>
				)}
			</Page>
		</Document>
	)
}
